<ui-object-navigation-main-page alias="si"></ui-object-navigation-main-page>